const getProductById = (id) => {
    return `
    query {
        product(id: "gid://shopify/Product/${id}") {
            id
            title
            handle
            availableForSale
            descriptionHtml
            totalInventory
            featuredImage {
                altText
                url
            }
            images(first: 200) {
                edges {
                    node {
                        url
                    }
                }
            }
            options(first: 24) {
                name
            }
            variants(first: 50) {
                nodes {
                    id
                    image {
                        altText
                        url
                    }
                    quantityAvailable
                    title
                    priceV2 {
                        amount
                    }
                    torsoOverlayValue: metafield(
                        namespace: "custom"
                        key: "torso_overlay"
                    ) {
                        value
                    }
                    skintoneValue: metafield(
                        namespace: "custom"
                        key: "skin_tone"
                    ) {
                        value
                    }
                    reverseImage: metafield(
                        namespace: "custom"
                        key: "reverse_image"
                    ) {
                        reference {
                            ... on MediaImage {
                              image {
                                url
                              }
                            }
                        }
                    }
                }
            }
            collections(first: 50) {
                edges {
                    node {
                        title
                    }
                }
            }
            tags
            productWarningValue: metafield(
                namespace: "custom"
                key: "product_warning"
            ) {
                value
            }
        }
      }
      `;
};

export default getProductById;
